<script lang="ts">
  import { userbaseStore, ArticleStore } from "../../stores/stores";
  import Button from "../../shared/Button.svelte";
  import Modal from "../../shared/Modal.svelte";
  import ArticleDetails from "./ArticleDetails.svelte";
  import AddArticleForm from "./AddArticleForm.svelte";
  import type { Article } from "../../stores/types";
  import { DatabaseName, ArticleType } from "../../stores/types";

  let articles = [];

  ArticleStore.subscribe((value) => {
    articles = value;
  });

  const databaseNameArticle = DatabaseName.ARTICLES.toString();
  function changeHandler(items: [Article]) {
    articles = items;
    articles.sort(function (a, b) {
      var nameA = a.item.name.toUpperCase();
      var nameB = b.item.name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });

    console.log(articles);
  }

  $: articlesPromise = $userbaseStore.openDatabase({
    databaseName: databaseNameArticle,
    changeHandler,
  });

  articles.sort(function (a, b) {
    var nameA = a.item.name.toUpperCase();
    var nameB = b.item.name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });

  let showModal = false;
  const toggleModal = () => {
    showModal = !showModal;
  };

  const addArticle = (e) => {
    showModal = false;
  };
</script>

<Modal {showModal} on:click={toggleModal}>
  <AddArticleForm on:addArticle={addArticle} />
</Modal>
<div>
  <div class="add-article">
    <Button type="secondary" on:click={toggleModal}>+ Neuer Artikel</Button>
  </div>
  <h2>Sauerteig</h2>
  <div class="article-list">
    {#each articles as { item, itemId }, index}
      {#if item.type === ArticleType.SAUERTEIG}
        <ArticleDetails {item} {itemId} />
      {/if}
    {/each}
  </div>
  <h2>Mehl</h2>
  <div class="article-list">
    {#each articles as { item, itemId }, index}
      {#if item.type === ArticleType.MEHL}
        <ArticleDetails {item} {itemId} />
      {/if}
    {/each}
  </div>
</div>

<style>
  .add-article {
    text-align: right;
  }
  .article-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 20px;
  }
</style>
